import { useContext, useEffect, useState } from "react";
import { LocaleContext } from "../../contexts/LocaleContext";
import provider_profile from "../../assets/images/provider_profile.jpg";
import { categoryService } from "../../services/categoryService";
import { useParams } from "react-router-dom";
import { toast } from "../../services/toastService";
import Loading from "../../components/common/Loading";
import BackButton from "../../components/common/BackButton";
import no_image_available from "../../assets/images/no_image_available.png";
import { urlConfig } from "../../config/baseUrl";

const CategoryDetails = () => {
  const { t } = useContext(LocaleContext);
  const [data,setData]=useState([]);
  const [loading,setLoading]=useState(true);
  const { id } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
    getDetailsAsync();
  },[])

  const getDetailsAsync = async () => {
    try {
      setLoading(true);
      const res = await categoryService.getDetails(id);
      if(!res.isSuccess)
      {
        toast.error(t("anErrorOccurredPleaseTryAgainLater"));
        console.log(res);
        return;
      }
      setData(res.value);
    } catch (error) {
      console.error(error);
    }
    finally {
      setLoading(false);
    }
  };

  if (loading) return <Loading />;
  return (
    <section className="section-category-details">
      <div className="default-heading">{t("categories")}</div>
      <div className="my-card">
        <div className="my-card-header d-flex justify-content-between align-items-center">
          {t("categoryDetails")}
          <BackButton />
        </div>
        <div className="my-card-dark">
          <div className="row">
            <div className="col-12 col-md-4">
              <div className="trip-provider-information">
                <div className="trip-provider-profile-layer">
                  <div className="trip-provider-profile">
                    <img
                      src={
                        data?.imagePath
                          ? `${urlConfig.imageBaseUrl}/${data.imagePath}`
                          : no_image_available
                      }
                      alt="Category Image"
                    />
                  </div>
                </div>
                {/* <b>
                  <i className="fas fa-images"></i> {t("edit")}
                </b> */}
              </div>
            </div>
            <div className="col-12 col-md-8">
              <div className="row h-100">
                <div className="col-12 col-md-12">
                  <div className="my-dark-card-items border-0">
                    <div className="my-dark-card-item ">
                      <strong>{data?.name}</strong>
                      <span>{data?.nameEn}</span>
                      <b>
                        {" "}
                        {t("creationDate")} :  {data?.createdAt?.toDate()}{" "}
                      </b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className=" mt-3">
          <strong>{t("statistics")}</strong>
          <section className="my-statistics mt-3">
            <div className="row g-3">
              <div className="col-12 col-md-4">
                <div className="my-box my-bg-primary">
                  <b>{t("totalTrips")}</b>
                  <span>{data?.trip?.totalTrips} </span>
                  <span>
                    {t("active")} : {data?.trip?.active} | {t("pending")} :{" "}
                    {data?.trip?.pending}
                  </span>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="my-box my-bg-dark-blue">
                  <b>{t("totalBookings")}</b>
                  <span>{data?.booking?.totalBookings}</span>
                  <span>
                    {t("completed")} : {data?.booking?.completed} |{" "}
                    {t("canceled")} : {data?.booking?.cancelled}
                  </span>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="my-box my-bg-primary">
                  <b>{t("totalProfits")}</b>
                  <span>
                    {data?.totalProfit} {t("riyal")}
                  </span>
                  <span>{t("fromCompletedBookings")}</span>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="my-box my-bg-dark-blue">
                  <b>{t("rating")}</b>
                  <span>{data?.rated} </span>
                  <span>
                    {t("from")} {data?.totalRatings} {t("rating")}
                  </span>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="my-box my-bg-primary">
                  <b>{t("totalTransfers")}</b>
                  <span>
                    {data?.totalTransfers} {t("riyal")}
                  </span>
                  <span>{t("fromCompletedBookings")}</span>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="my-box my-bg-dark-blue">
                  <b>{t("totalRevenues")}</b>
                  <span>
                    {data?.totalRevenue} {t("riyal")}
                  </span>
                  <span>{t("fromCompletedBookings")}</span>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </section>
  );
};

export default CategoryDetails;
